'use client';

import { Select } from '@mui/material';
import { CSSProperties } from 'react';

import { styled } from '../../styles';
import { MEDIUM_INPUT_HEIGHT, SMALL_INPUT_HEIGHT } from '../../theme/constants';
import { getDropdownMaxHeight } from '../../utils';

import { StyledSelectProps } from './types';

export const StyledSelect = styled(
  ({ className, MenuProps, ...props }: StyledSelectProps) => (
    <Select
      MenuProps={{ classes: { list: className }, ...MenuProps }}
      {...props}
    />
  ),
)<StyledSelectProps>(({ size, disableScroll }) => ({
  maxHeight: getDropdownMaxHeight(size),
  ...(disableScroll && {
    overflow: 'hidden',
  }),
}));

export const SelectItem = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

export const MediumSelectValue = styled(SelectItem)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  height: `${MEDIUM_INPUT_HEIGHT}px`,
  ...(theme.typography.body2 as CSSProperties),
}));

export const SmallSelectValue = styled(SelectItem)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: `${SMALL_INPUT_HEIGHT}px`,
  ...(theme.typography.body3 as CSSProperties),
}));

export const SelectItemLabel = styled.span(() => ({
  flex: 1,
  textAlign: 'start' as const,
}));

export const SelectItemPlaceholder = styled.span(({ theme }) => ({
  flex: 1,
  color: theme.palette.text3,
  textAlign: 'start',
}));
